import {
  FormLabelInput,
  TitleInputContainer,
  TitleDescription,
  MessageInputContainer,
  FormLabel,
} from "@/components/ui/form-elements";
import EdsSearchableSelect from "../EdsSearchableSelect";
import NodeContext from "../../context/NodeContext";
import { useContext } from "react";
import { NODE_TYPE } from "../../utils/constants";
import { LABELS } from "../../utils/labels";
import { useCallback } from "react";

function JumpToNodeEditor() {
  const { selectedNodeInfo, updateNode, nodes, isEditable } =
    useContext(NodeContext);

  const createOptions = useCallback(() => {
    const options = [];
    options.push({ value: "0", label: "Select an action block" });
    nodes
      .filter(
        (node) =>
          node?.type !== NODE_TYPE.END_NODE &&
          node?.type !== NODE_TYPE.STARTING_NODE &&
          node?.type !== NODE_TYPE.JUMP_TO_NODE &&
          node.data.buttonType !== "branchButton"
      )
      .forEach((node) => {
        options.push({
          value: node?.id,
          label: node?.data?.titleText,
        });
      });
    return options;
  }, [nodes]);

  if (!selectedNodeInfo) {
    return null;
  }

  return (
    <>
      <TitleInputContainer>
        <FormLabelInput
          placeholder="Label"
          value={selectedNodeInfo?.data?.titleText}
          onChange={(e) => {
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              titleText: e.target.value,
            });
          }}
          readOnly={!isEditable}
        />
        <TitleDescription>
          Allows you to route the conversation flow from this point to the
          action block mentioned below.
        </TitleDescription>
      </TitleInputContainer>
      <MessageInputContainer>
        <FormLabel>{LABELS.GO_TO_ACTION}</FormLabel>
        <EdsSearchableSelect
          options={createOptions()}
          value={selectedNodeInfo?.data?.value || "0"}
          onChange={(value) => {
            const selectedOption = createOptions().find((o) => o.value === value);
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              value: value || "0",
              label: selectedOption ? selectedOption.label : "Select an action block",
            });
          }}
          isClearable = { (selectedNodeInfo?.data?.value || "0") !== "0"}
          isDisabled={!isEditable}
          placeholder="Select an action block"
          key={selectedNodeInfo?.id}
        />
      </MessageInputContainer>
    </>
  );
}

export default JumpToNodeEditor;
